import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  PERMISSION_LOAD_PROJECT_DETAIL_BEGIN,
  PERMISSION_LOAD_PROJECT_DETAIL_SUCCESS,
  PERMISSION_LOAD_PROJECT_DETAIL_FAILURE,
  PERMISSION_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function loadProjectDetail(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PERMISSION_LOAD_PROJECT_DETAIL_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PERMISSION_LOAD_PROJECT_DETAIL_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PERMISSION_LOAD_PROJECT_DETAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailError() {
  return {
    type: PERMISSION_LOAD_PROJECT_DETAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERMISSION_LOAD_PROJECT_DETAIL_BEGIN:
      return {
        ...state,
        loadProjectDetailPending: true,
        loadProjectDetailError: null,
      };

    case PERMISSION_LOAD_PROJECT_DETAIL_SUCCESS:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: null,
        projectDetail: action.data,
      };

    case PERMISSION_LOAD_PROJECT_DETAIL_FAILURE:
      return {
        ...state,
        loadProjectDetailPending: false,
        loadProjectDetailError: action.data.error,
      };

    case PERMISSION_LOAD_PROJECT_DETAIL_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailError: null,
      };

    default:
      return state;
  }
}
